import {
    CREATE_MAIN_MODULE,
    CREATE_MAIN_MODULE_SUCCESS,
    CREATE_MAIN_MODULE_FAILURE,
    GET_MAIN_MODULE_LIST,
    GET_MAIN_MODULE_LIST_SUCCESS,
    GET_MAIN_MODULE_LIST_FAILURE,
    UPDATE_MAIN_MODULE,
    UPDATE_MAIN_MODULE_SUCCESS,
    UPDATE_MAIN_MODULE_FAILURE,
    VIEW_MAIN_MODULE,
    VIEW_MAIN_MODULE_SUCCESS,
    VIEW_MAIN_MODULE_FAILURE,
    UPDATE_STATUS_MAIN_MODULE,
    UPDATE_STATUS_MAIN_MODULE_SUCCESS,
    UPDATE_STATUS_MAIN_MODULE_FAILURE
  } from "../types";
  
  export const createMainModule = (payload) => ({
    type: CREATE_MAIN_MODULE,
    payload,
  });
  
  export const createMainModuleSuccess = (payload) => ({
    type: CREATE_MAIN_MODULE_SUCCESS,
    payload,
  });
  
  export const createMainModuleFailure = (payload) => ({
    type: CREATE_MAIN_MODULE_FAILURE,
    payload,
  });
  
  export const getMainModuleList = (payload) => ({
    type: GET_MAIN_MODULE_LIST,
    payload,
  });
  
  export const getMainModuleListSuccess = (payload) => ({
    type: GET_MAIN_MODULE_LIST_SUCCESS,
    payload,
  });
  
  export const getMainModuleListFailure = (payload) => ({
    type: GET_MAIN_MODULE_LIST_FAILURE,
    payload,
  });
  
  
  export const updateMainModule = (payload) => ({
    type: UPDATE_MAIN_MODULE,
    payload,
  });
  
  export const updateMainModuleSuccess = (payload) => ({
    type: UPDATE_MAIN_MODULE_SUCCESS,
    payload,
  });
  
  export const updateMainModuleFailure = (payload) => ({
    type: UPDATE_MAIN_MODULE_FAILURE,
    payload,
  });
  
  export const updateStatusMainModule = (payload) => ({
    type: UPDATE_STATUS_MAIN_MODULE,
    payload,
  });
  
  export const updateStatusMainModuleSuccess = (payload) => ({
    type: UPDATE_STATUS_MAIN_MODULE_SUCCESS,
    payload,
  });
  
  export const updateStatusMainModuleFailure = (payload) => ({
    type: UPDATE_STATUS_MAIN_MODULE_FAILURE,
    payload,
  });
  
  export const viewMainModule = (payload) => ({
    type: VIEW_MAIN_MODULE,
    payload,
  });
  
  export const viewMainModuleSuccess = (payload) => ({
    type: VIEW_MAIN_MODULE_SUCCESS,
    payload,
  });
  
  export const viewMainModuleFailure = (payload) => ({
    type: VIEW_MAIN_MODULE_FAILURE,
    payload,
  });